import votesReducer from "../reducers/VotesReducer";

export const selectVotes = votesReducer.selectState;
